import { motion, useReducedMotion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 24, className = '' }) => {
  const reduceMotion = useReducedMotion();
  return (
    <motion.div
      initial={reduceMotion ? false : { opacity: 0, y }}
      whileInView={reduceMotion ? undefined : { opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={reduceMotion ? { duration: 0 } : { duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const Eyebrow = ({ children, light = false }) => (
  <span className={"inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.22em] " + (light ? "text-aqua" : "text-electric")}>
    <span className={"h-px w-8 " + (light ? "bg-aqua/70" : "bg-electric/60")} aria-hidden="true" />
    {children}
  </span>
);
